<div
  class="bottom-bar"
  [ngClass]="{ 'reply-open': composeMode }"
  *ngIf="thread != null || newEmailMode"
>
  <div *ngIf="!composeMode" class="default buttons-wrapper">
    <div class="buttons-left">
      <button class="btn btn-danger me-3" (click)="moveToTrash.emit()">
        <i class="feather trash"></i> Move to Trash
      </button>
    </div>
    <div class="buttons-right">
      <!-- <button
        *ngIf="thread?.summary == null && !newEmailMode"
        (click)="summarizeThread()"
        class="btn btn-primary-light me-3"
        [ngClass]="{ 'btn-loading': summarizeLoading }"
      >
        <i class="tio-format_bullets"></i>
        Summarize thread
      </button> -->
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-primary"
          (click)="setComposeMode(true, false)"
        >
          Reply All
        </button>
        <span dropdown [dropup]="isDropup" [autoClose]="true">
          <button
            dropdownToggle
            type="button"
            class="btn btn-primary"
            style="
              width: 32px;
              padding: 6px 0px;
              padding-right: 6px;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              text-align: center;
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.45989 6.165C8.56528 6.05948 8.70826 6.00013 8.85739 6H9.14239C9.2912 6.00173 9.4336 6.06084 9.53989 6.165L13.3874 10.02C13.4225 10.0549 13.4504 10.0963 13.4695 10.142C13.4885 10.1877 13.4983 10.2367 13.4983 10.2863C13.4983 10.3358 13.4885 10.3848 13.4695 10.4305C13.4504 10.4762 13.4225 10.5176 13.3874 10.5525L12.8549 11.085C12.8207 11.1199 12.7798 11.1477 12.7348 11.1666C12.6897 11.1855 12.6413 11.1953 12.5924 11.1953C12.5435 11.1953 12.4951 11.1855 12.45 11.1666C12.4049 11.1477 12.3641 11.1199 12.3299 11.085L8.99989 7.7475L5.66989 11.085C5.63503 11.1201 5.59355 11.148 5.54786 11.1671C5.50216 11.1861 5.45314 11.1959 5.40364 11.1959C5.35413 11.1959 5.30512 11.1861 5.25942 11.1671C5.21373 11.148 5.17225 11.1201 5.13739 11.085L4.61239 10.5525C4.57724 10.5176 4.54934 10.4762 4.53031 10.4305C4.51127 10.3848 4.50146 10.3358 4.50146 10.2863C4.50146 10.2367 4.51127 10.1877 4.53031 10.142C4.54934 10.0963 4.57724 10.0549 4.61239 10.02L8.45989 6.165Z"
                fill="white"
                style="fill: white; fill-opacity: 1"
              />
            </svg>
          </button>
          <ul class="dropdown-menu dropdown-send" *dropdownMenu>
            <li>
              <a (click)="setComposeMode(true, true)">Reply to sender</a>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="composeMode" class="compose">
    <div class="compose-addresses to">
      <label for="to" class="compose-address-label" style="min-width: 20px"
        >To</label
      >
      <p-autocomplete
        styleClass="compose-address-autocomplete"
        placeholder=""
        multiple
        fluid
        [(ngModel)]="newEmail.to"
        [typeahead]="false"
        (onBlur)="addChipOnBlur(newEmail.to, $event)"
        (keydown)="addChipOnComma(newEmail.to, $event)"
        [unique]="true"
      ></p-autocomplete>
      <a style="flex-shrink: 0" *ngIf="!cc" (click)="cc = true">Cc</a>
      <a style="flex-shrink: 0" *ngIf="!bcc" (click)="bcc = true">Bcc</a>
    </div>
    <div class="compose-addresses cc" *ngIf="cc">
      <label for="cc" class="compose-address-label" style="min-width: 20px"
        >Cc</label
      >
      <p-autocomplete
        styleClass="compose-address-autocomplete"
        placeholder=""
        multiple
        fluid
        [(ngModel)]="newEmail.cc"
        [typeahead]="false"
        (onBlur)="addChipOnBlur(newEmail.cc, $event)"
        (keydown)="addChipOnComma(newEmail.cc, $event)"
        [unique]="true"
      ></p-autocomplete>
    </div>
    <div class="compose-addresses bcc" *ngIf="bcc">
      <label for="bcc" class="compose-address-label" style="min-width: 20px"
        >Bcc</label
      >
      <p-autocomplete
        styleClass="compose-address-autocomplete"
        multiple
        fluid
        [(ngModel)]="newEmail.bcc"
        [typeahead]="false"
        (onBlur)="addChipOnBlur(newEmail.bcc, $event)"
        (keydown)="addChipOnComma(newEmail.bcc, $event)"
        [unique]="true"
      ></p-autocomplete>
    </div>
    <div class="compose-addresses subject">
      <label for="subject" class="compose-address-label" style="min-width: 20px"
        >Subject</label
      >

      <input
        style="height: 29px"
        type="text"
        name="subject"
        id="subject"
        [(ngModel)]="newEmail.subject"
      />
    </div>
    <label class="compose-message">
      <!-- <textarea
          #messageInput
          class=""
          rows="1"
          autosize
          [disabled]="generateAiLoading || changeEmailToneLoading"
          [(ngModel)]="
            modifiedMessage != null ? modifiedMessage : newEmail.body
          "
          placeholder="Type your message"
          style="
            white-space: pre-wrap;
            overflow-wrap: break-word;
            min-height: 80px;
          "
        ></textarea> -->

      <!-- <ejs-richtexteditor
        #messageInput
        placeholder="Type your message"
        [value]="modifiedMessage != null ? modifiedMessage : newEmail.body"
        (valueChange)="
          modifiedMessage != null ? modifiedMessage : (newEmail.body = $event)
        "
        [inlineMode]="inlineMode"
        [toolbarSettings]="toolbarSettings"
      >
      </ejs-richtexteditor> -->

      @if (modifiedMessage != null) {
        <p-editor
          #messageInput
          [(ngModel)]="modifiedMessage"
          [style]="{ height: '320px' }"
          [ngClass]="{ 'ai-animation': animateEditor }"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-font ql-picker">
                <option selected>Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select
                title="Text Color"
                class="ql-color"
                defaultValue="rgb(0, 0, 0)"
              ></select>
              <span class="ql-format-separator"></span>
              <select
                title="Background Color"
                class="ql-background"
                defaultValue="rgb(255, 255, 255)"
              ></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" type="button"></button>
              <button class="ql-list" value="bullet" type="button"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button aria-label="Image" class="ql-image"></button>
            </span>
          </p-header>
        </p-editor>
      }
      @if (modifiedMessage == null) {
        <p-editor
          #messageInput
          [(ngModel)]="newEmail.body"
          [style]="{ height: '320px' }"
          [ngClass]="{ 'ai-animation': animateEditor }"
        >
          <p-header>
            <span class="ql-formats">
              <select class="ql-font ql-picker">
                <option selected>Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
              <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
              <select
                title="Text Color"
                class="ql-color"
                defaultValue="rgb(0, 0, 0)"
              ></select>
              <span class="ql-format-separator"></span>
              <select
                title="Background Color"
                class="ql-background"
                defaultValue="rgb(255, 255, 255)"
              ></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered" type="button"></button>
              <button class="ql-list" value="bullet" type="button"></button>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button aria-label="Image" class="ql-image"></button>
            </span>
          </p-header>
        </p-editor>
      }

      <div class="compose-ai-buttons ms-4">
        <!-- <button
            class="btn btn-o"
            title="Generate using AI"
            [ngClass]="{ 'btn-loading': generateAiLoading }"
          >
            <i class="sparkle-icon"></i>
            Generate
          </button> -->
        <!-- <button
          class="btn btn-primary"
          *ngIf="!newEmailMode"
          (click)="openModal(magicReplyModal)"
          title="Change tone using AI"
          [ngClass]="{ 'btn-loading': generateMagicEmailLoading }"
        >
          <i class="sparkle-icon"></i>
          Magic Reply
        </button> -->
        <button
          *ngIf="!newEmailMode"
          class="quick-action-button reply-yes"
          (click)="quickAction('Reply Yes', $event)"
        >
          <i class="icon tio-thumbs_up"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Reply Yes
        </button>
        <button
          *ngIf="!newEmailMode"
          class="quick-action-button reply-no"
          (click)="quickAction('Reply No', $event)"
        >
          <i class="icon tio-thumbs_down"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Reply No
        </button>
        <!-- Disabled for now -->
        <!-- <button class="quick-action-button btn-ai">
          <i class="sparkle-icon"></i> Magic Search & Draft
        </button> -->
        <button
          class="quick-action-button btn-ai"
          (click)="openAIComposerDialog()"
        >
          <i class="sparkle-icon"></i> AI Composer
        </button>
      </div>
    </label>
    <div class="buttons-wrapper">
      <div class="buttons-left">
        <button class="btn btn-default" (click)="cancelComposeMode()">
          Cancel
        </button>
      </div>
      <div class="buttons-center d-flex gap-2">
        <div
          class="dropup"
          dropdown
          [dropup]="true"
          [autoClose]="true"
          [isDisabled]="
            animateEditor ||
            newEmail.body == '\n\n<p></p>' ||
            newEmail.body == '' ||
            newEmail.body == '<p></p>'
          "
        >
          <button
            class="btn btn-ai dropdown-toggle"
            dropdownToggle
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title="Change tone using AI"
          >
            <i class="icon tio-slightly_smilling" style="font-size: 18px"></i>
            <p-progress-spinner
              class="icon-loading"
              strokeWidth="5"
              fill="transparent"
              animationDuration=".5s"
              [style]="{ width: '16px', height: '16px' }"
            />
            Change tone
          </button>

          <ul class="dropdown-menu" *dropdownMenu>
            <li (click)="changeEmailTone('cheerful', $event)">
              <a>😁 Cheerful</a>
            </li>
            <li (click)="changeEmailTone('decisive', $event)">
              <a>🤔 Decisive</a>
            </li>
            <li (click)="changeEmailTone('casual', $event)">
              <a>👕 Casual</a>
            </li>
            <li (click)="changeEmailTone('encouraging', $event)">
              <a>💪 Encouraging</a>
            </li>
            <li (click)="changeEmailTone('formal', $event)">
              <a>🧑‍💼 Formal</a>
            </li>
          </ul>
        </div>
        <button
          class="btn btn-ai"
          title="Expand Text"
          [disabled]="
            animateEditor ||
            newEmail.body == '\n\n<p></p>' ||
            newEmail.body == '' ||
            newEmail.body == '<p></p>'
          "
          (click)="
            quickAction(
              'Make this text longer, you can almost double its length: ' +
                newEmail.body,
              $event
            )
          "
        >
          <i class="icon tio-menu_hamburger"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Expand
        </button>
        <button
          class="btn btn-ai"
          title="Shorten Text"
          [disabled]="
            animateEditor ||
            newEmail.body == '\n\n<p></p>' ||
            newEmail.body == '' ||
            newEmail.body == '<p></p>'
          "
          (click)="
            quickAction(
              'Make this text as short as possible, possibly making it one sentence only if you can: ' +
                newEmail.body,
              $event
            )
          "
        >
          <i class="icon tio-menu_left"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Shorten
        </button>
      </div>
      <div class="buttons-right">
        <!-- <button
          *ngIf="thread?.summary == null && !newEmailMode"
          (click)="summarizeThread()"
          class="btn btn-primary-light me-3"
          [ngClass]="{ 'btn-loading': summarizeLoading }"
        >
          <i class="tio-format_bullets"></i>
          Summarize thread
        </button> -->

        <div class="buttons-left" *ngIf="newEmailMode">
          <button class="btn btn-primary" (click)="sendEmail()">Send</button>
        </div>
        <span *ngIf="!newEmailMode">
          <button
            type="button"
            class="btn btn-primary"
            (click)="sendEmail()"
            [disabled]="
              animateEditor ||
              newEmail.body == '\n\n<p></p>' ||
              newEmail.body == '' ||
              newEmail.body == '<p></p>'
            "
          >
            @if (composeMode == true) {
              <i class="tio-send"></i> Send
            } @else {
              Reply All
            }
          </button>
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Magic Reply -->
<ng-template #magicReplyModal class="magicReplyModal">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
      [disabled]="loading"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Magic Reply</h4>
  </div>
  <div
    class="modal-body white text-center create-job-modal"
    [ngClass]="{ 'is-loading': loading }"
  >
    <div class="ai-bot-wrapper">
      <div class="ai-bot-face ai-bot-loading-wrapper">
        <img
          class="ai-bot-face ai-bot-loading"
          src="/assets/img/ai-bot-loading.svg"
        />
        <img
          class="ai-bot-face ai-bot-sparkles"
          src="/assets/img/ai-bot-sparkles.svg"
        />
      </div>
      <img class="ai-bot-face ai-bot-eyes" src="/assets/img/ai-bot-eyes.svg" />
      <img
        class="ai-bot animated"
        src="/assets/img/ai-bot.svg"
        alt="AI Bot avatar"
      />
      <svg
        class="ai-bot-shadow"
        width="134"
        height="28"
        viewBox="0 0 134 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse cx="67" cy="14" rx="67" ry="14" fill="#E6E9ED" />
      </svg>
    </div>
    <div class="default-content">
      <h3 class="mt-0 mb-2">Briefly describe the reply you want</h3>
      <p>We will auto-generate a reply using AI.</p>
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <textarea
            class="form-control chat-input my-4"
            autosize
            [(ngModel)]="magicReplyPrompt"
            placeholder="e.g. polite thank you"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="loading-content">
      <h3 class="mt-0 mb-2">Generating Reply using AI</h3>
      <p>Please wait, it may take up to 30 seconds.</p>
    </div>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-default pull-left"
      aria-label="Cancel"
      (click)="bsModalRef.hide()"
      [disabled]="loading"
      *ngIf="!loading"
    >
      Cancel
    </div>
    <button
      class="btn btn-purple pull-right"
      (click)="generateMagicEmail()"
      [disabled]="loading"
    >
      Generate Reply
    </button>
  </div>
</ng-template>
<!-- End Magic Reply -->

<!-- AI Composer -->
<p-dialog
  header="AI Composer"
  class="ai-composer-dialog"
  [ngClass]="{ animated: animateAIDialog || generateMagicEmailLoading }"
  [modal]="true"
  [(visible)]="aiComposerVisible"
  [position]="position"
  [style]="{ width: '60vw' }"
  [draggable]="false"
  (onHide)="clearEmailDraft()"
>
  <div *ngIf="generateMagicEmailLoading" class="text-center p-4">
    <p-skeleton styleClass="mb-2" />
    <p-skeleton width="10rem" styleClass="mb-2" />
    <p-skeleton width="5rem" styleClass="mb-2" />
  </div>
  @if (generateMagicEmailInitialState) {
    <div class="">
      <h4 class="mt-0 mb-2">Briefly describe the reply you want</h4>
      <p>We will auto-generate a reply using AI.</p>
    </div>
  }
  @if (showEmailBody) {
    <div class="mt-2 draft-wrapper" (click)="toggleEmailBodyEdit()">
      <div class="generated-email-wrapper" *ngIf="!isEditingEmailBody">
        <span
          class="generated-email"
          [innerHTML]="aiComposerDraft.trim()"
        ></span>
      </div>
      <div
        *ngIf="isEditingEmailBody"
        class="generated-email generated-email-editable"
        contenteditable="true"
        (blur)="saveDraftEdit()"
        (paste)="handlePaste($event)"
        [innerHTML]="aiComposerDraft"
      ></div>
      <!-- <span *ngIf="animateAIDialog" class="cursor"></span> -->
    </div>
  }
  @if (showEmailBodyActions) {
    <div class="action-buttons flex justify-end gap-4 mt-4">
      <div class="flex justify-end gap-2">
        <div class="dropup" dropdown [dropup]="true" [autoClose]="true">
          <button
            class="btn btn-ai dropdown-toggle"
            dropdownToggle
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            title="Change tone using AI"
          >
            <i class="icon tio-slightly_smilling" style="font-size: 18px"></i>
            <p-progress-spinner
              class="icon-loading"
              strokeWidth="5"
              fill="transparent"
              animationDuration=".5s"
              [style]="{ width: '16px', height: '16px' }"
            />
            Change tone
          </button>

          <ul class="dropdown-menu" *dropdownMenu>
            <li (click)="changeEmailTone('cheerful', $event, true)">
              <a>😁 Cheerful</a>
            </li>
            <li (click)="changeEmailTone('decisive', $event, true)">
              <a>🤔 Decisive</a>
            </li>
            <li (click)="changeEmailTone('casual', $event, true)">
              <a>👕 Casual</a>
            </li>
            <li (click)="changeEmailTone('encouraging', $event, true)">
              <a>💪 Encouraging</a>
            </li>
            <li (click)="changeEmailTone('formal', $event, true)">
              <a>🧑‍💼 Formal</a>
            </li>
          </ul>
        </div>
        <button
          class="btn btn-ai"
          title="Expand Text"
          (click)="
            generateMagicEmail(
              'Make this text longer, you can almost double its length: ' +
                aiComposerDraft,
              $event
            )
          "
        >
          <i class="icon tio-menu_hamburger"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Expand
        </button>
        <button
          class="btn btn-ai"
          title="Shorten Text"
          (click)="
            generateMagicEmail(
              'Make this text as short as possible, possibly making it one sentence only if you can: ' +
                aiComposerDraft,
              $event
            )
          "
        >
          <i class="icon tio-menu_left"></i>
          <p-progress-spinner
            class="icon-loading"
            strokeWidth="5"
            fill="transparent"
            animationDuration=".5s"
            [style]="{ width: '16px', height: '16px' }"
          />
          Shorten
        </button>
      </div>
      <button class="btn btn-purple" (click)="insertEmailBodyFromDraft()">
        <i class="tio-enter"></i> Insert
      </button>
    </div>
  }
  <div class="flex justify-end msg-input-wrapper">
    <textarea
      class="form-control mt-4"
      autosize
      rows="1"
      [(ngModel)]="magicReplyPrompt"
      placeholder="e.g. polite thank you"
      (keydown)="handleKeyDown($event)"
      #magicReplyInput
    ></textarea>
    <button class="send-btn" (click)="generateMagicEmail()">
      <i class="tio-send"></i>
    </button>
  </div>
</p-dialog>
<!-- End AI Composer -->
